import React, { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ContactSection from "@/components/ContactSection";

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);
  return (
    <div data-testid="contact-page" className="grain">
      <Header />
      <main className="pt-24 md:pt-28">
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
